// @ts-nocheck
import * as Types from '../../../../../gql/generated/graphql.gen';

import { gql } from '@apollo/client';
export type PlanDataTableFragmentFieldsFragment = { __typename?: 'PlanPrice', id: string, name: string, price: number, couponErrorReason?: string | null, subscriptionCoupon?: { __typename?: 'SubscriptionCoupon', discountAmount: number, duration: string, durationInMonths?: number | null } | null };

export const PlanDataTableFragmentFieldsFragmentDoc = gql`
    fragment PlanDataTableFragmentFields on PlanPrice {
  id
  name
  price
  subscriptionCoupon {
    discountAmount
    duration
    durationInMonths
  }
  couponErrorReason
}
    `;